import {useState, useEffect} from 'react';
import {useSearchParams, useNavigate} from 'react-router-dom';
import {downloadPdf} from '../api/pdfDownload';

export default function PdfDownload() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('t');

    const [phase, setPhase] = useState('downloading'); // downloading | done | error

    useEffect(() => {
        if (!token) {
            navigate('/error/link-expired', {replace: true});
            return;
        }

        let cancelled = false;

        downloadPdf(token)
            .then(({blob, fileName}) => {
                if (cancelled) return;
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
                setPhase('done');
            })
            .catch(() => {
                if (cancelled) return;
                setPhase('error');
            });

        return () => {
            cancelled = true;
        };
    }, [token, navigate]);

    if (phase === 'downloading') {
        return (
            <div className="card card--form">
                <div className="loader">
                    <div className="loader-spinner"/>
                    <span>Download in corso…</span>
                </div>
            </div>
        );
    }

    if (phase === 'error') {
        return (
            <div className="card card--form">
                <h2>Scarica Documento</h2>
                <div className="error-msg" role="alert">
                    Errore durante il download. Riprova o verifica che il link sia ancora valido.
                </div>
            </div>
        );
    }

    return (
        <div className="card card--form">
            <h2>Scarica Documento</h2>
            <p style={{color: '#2e7d32'}}>
                Download completato!
            </p>
        </div>
    );
}
